import { useRef, useCallback } from 'react'
import cn from 'clsx'

import { FaFileUpload } from 'react-icons/fa'

const MiniUploadWidget = ({
    className,
    file,
    setFile,
}) => {
    
    const refInput = useRef()
    
    const onFileChange = useCallback(e => {
        
        if (e.target?.files?.length)
            setFile(e.target.files[0])
        
    }, [])
    
    return (
        
        <div className={cn('MiniUploadWidget shrink-0 w-auto block grow', className)}>
            
            <input
                ref={refInput}
                className="invisible hidden"
                type="file"
                multiple={false}
                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/pdf"
                onChange={onFileChange} />
            
            <button
                className="ml-3 btn btn-secondary shrink-0 w-auto block grow"
                onClick={() => refInput.current?.click()}>
                <div className="flex items-center content-center justify-between">
                    <span>{file?.name ?? 'Select file'}</span>
                    <FaFileUpload className="ml-3" />
                </div>
            </button>
        
        </div>
        
    )
    
}

export default MiniUploadWidget
